import React from "react";

/* Small reusable ER decoration SVGs */

const EntitySketch = ({ className, name, cols, color = "#06B6D4", w = 140 }) => (
  <svg width={w} height={24 + cols.length * 18} className={className} viewBox={`0 0 ${w} ${24 + cols.length * 18}`}>
    <rect width={w} height={24 + cols.length * 18} rx="3" fill="none" stroke={color} strokeWidth="0.8" />
    <rect width={w} height="22" rx="3" fill={color} fillOpacity="0.08" stroke={color} strokeWidth="0.8" />
    <text x={w / 2} y="15" textAnchor="middle" fill={color} fontSize="9" fontFamily="Fira Code, monospace" fontWeight="600">{name}</text>
    <line x1="0" y1="22" x2={w} y2="22" stroke={color} strokeWidth="0.5" />
    {cols.map((c, i) => (
      <text key={i} x="10" y={38 + i * 18} fill={color} fontSize="8" fontFamily="Fira Code, monospace" opacity="0.8">{c}</text>
    ))}
  </svg>
);

const StarSchemaSketch = ({ className, color = "#06B6D4" }) => (
  <svg width="200" height="140" className={className} viewBox="0 0 200 140">
    {/* Fact table center */}
    <rect x="60" y="50" width="80" height="32" rx="3" fill={color} fillOpacity="0.06" stroke={color} strokeWidth="0.8" />
    <text x="100" y="70" textAnchor="middle" fill={color} fontSize="8" fontFamily="Fira Code, monospace">FACT_SALES</text>
    {/* Dim top */}
    <rect x="65" y="0" width="70" height="26" rx="3" fill="none" stroke={color} strokeWidth="0.6" />
    <text x="100" y="16" textAnchor="middle" fill={color} fontSize="7" fontFamily="Fira Code, monospace">DIM_DATE</text>
    <line x1="100" y1="26" x2="100" y2="50" stroke={color} strokeWidth="0.5" strokeDasharray="3 2" />
    {/* Dim left */}
    <rect x="0" y="54" width="46" height="24" rx="3" fill="none" stroke={color} strokeWidth="0.6" />
    <text x="23" y="70" textAnchor="middle" fill={color} fontSize="6" fontFamily="Fira Code, monospace">DIM_PROD</text>
    <line x1="46" y1="66" x2="60" y2="66" stroke={color} strokeWidth="0.5" strokeDasharray="3 2" />
    {/* Dim right */}
    <rect x="154" y="54" width="46" height="24" rx="3" fill="none" stroke={color} strokeWidth="0.6" />
    <text x="177" y="70" textAnchor="middle" fill={color} fontSize="6" fontFamily="Fira Code, monospace">DIM_CUST</text>
    <line x1="140" y1="66" x2="154" y2="66" stroke={color} strokeWidth="0.5" strokeDasharray="3 2" />
    {/* Dim bottom */}
    <rect x="60" y="106" width="80" height="26" rx="3" fill="none" stroke={color} strokeWidth="0.6" />
    <text x="100" y="123" textAnchor="middle" fill={color} fontSize="7" fontFamily="Fira Code, monospace">DIM_STORE</text>
    <line x1="100" y1="82" x2="100" y2="106" stroke={color} strokeWidth="0.5" strokeDasharray="3 2" />
  </svg>
);

const ETLSketch = ({ className, color = "#06B6D4" }) => (
  <svg width="360" height="36" className={className} viewBox="0 0 360 36">
    <rect x="0" y="6" width="55" height="22" rx="3" fill="none" stroke={color} strokeWidth="0.7" />
    <text x="28" y="21" textAnchor="middle" fill={color} fontSize="7" fontFamily="Fira Code, monospace">SOURCE</text>
    <line x1="55" y1="17" x2="80" y2="17" stroke={color} strokeWidth="0.5" />
    <polygon points="78,14 85,17 78,20" fill={color} />
    <rect x="85" y="6" width="52" height="22" rx="3" fill="none" stroke={color} strokeWidth="0.7" />
    <text x="111" y="21" textAnchor="middle" fill={color} fontSize="7" fontFamily="Fira Code, monospace">EXTRACT</text>
    <line x1="137" y1="17" x2="160" y2="17" stroke={color} strokeWidth="0.5" />
    <polygon points="158,14 165,17 158,20" fill={color} />
    <polygon points="200,2 235,17 200,32 165,17" fill="none" stroke={color} strokeWidth="0.7" />
    <text x="200" y="20" textAnchor="middle" fill={color} fontSize="6" fontFamily="Fira Code, monospace">TRANSFORM</text>
    <line x1="235" y1="17" x2="258" y2="17" stroke={color} strokeWidth="0.5" />
    <polygon points="256,14 263,17 256,20" fill={color} />
    <rect x="263" y="6" width="42" height="22" rx="3" fill="none" stroke={color} strokeWidth="0.7" />
    <text x="284" y="21" textAnchor="middle" fill={color} fontSize="7" fontFamily="Fira Code, monospace">LOAD</text>
    <line x1="305" y1="17" x2="322" y2="17" stroke={color} strokeWidth="0.5" />
    <polygon points="320,14 327,17 320,20" fill={color} />
    <ellipse cx="345" cy="11" rx="15" ry="6" fill="none" stroke={color} strokeWidth="0.6" />
    <line x1="330" y1="11" x2="330" y2="24" stroke={color} strokeWidth="0.6" />
    <line x1="360" y1="11" x2="360" y2="24" stroke={color} strokeWidth="0.6" />
    <ellipse cx="345" cy="24" rx="15" ry="6" fill="none" stroke={color} strokeWidth="0.6" />
    <text x="345" y="20" textAnchor="middle" fill={color} fontSize="6" fontFamily="Fira Code, monospace">DW</text>
  </svg>
);

const CrowsFootSketch = ({ className, color = "#06B6D4" }) => (
  <svg width="80" height="40" className={className} viewBox="0 0 80 40">
    <line x1="0" y1="18" x2="65" y2="18" stroke={color} strokeWidth="0.8" />
    <line x1="4" y1="8" x2="4" y2="28" stroke={color} strokeWidth="0.8" />
    <line x1="65" y1="18" x2="52" y2="6" stroke={color} strokeWidth="0.8" />
    <line x1="65" y1="18" x2="52" y2="30" stroke={color} strokeWidth="0.8" />
    <line x1="65" y1="18" x2="52" y2="18" stroke={color} strokeWidth="0.8" />
    <text x="8" y="36" fill={color} fontSize="7" fontFamily="Fira Code, monospace">1</text>
    <text x="56" y="36" fill={color} fontSize="7" fontFamily="Fira Code, monospace">N</text>
  </svg>
);

const DBCylinderSketch = ({ className, label = "DW", color = "#06B6D4" }) => (
  <svg width="66" height="58" className={className} viewBox="0 0 66 58">
    <ellipse cx="33" cy="10" rx="28" ry="9" fill="none" stroke={color} strokeWidth="0.8" />
    <line x1="5" y1="10" x2="5" y2="44" stroke={color} strokeWidth="0.8" />
    <line x1="61" y1="10" x2="61" y2="44" stroke={color} strokeWidth="0.8" />
    <ellipse cx="33" cy="44" rx="28" ry="9" fill="none" stroke={color} strokeWidth="0.8" />
    <text x="33" y="31" textAnchor="middle" fill={color} fontSize="8" fontFamily="Fira Code, monospace">{label}</text>
  </svg>
);

const RelDiamondSketch = ({ className, label = "HAS", color = "#06B6D4" }) => (
  <svg width="80" height="54" className={className} viewBox="0 0 80 54">
    <polygon points="40,2 78,27 40,52 2,27" fill="none" stroke={color} strokeWidth="0.8" />
    <text x="40" y="30" textAnchor="middle" fill={color} fontSize="8" fontFamily="Fira Code, monospace">{label}</text>
  </svg>
);

const SQLSketch = ({ className, color = "#06B6D4" }) => (
  <svg width="160" height="56" className={className} viewBox="0 0 160 56">
    <text x="0" y="10" fill="#F59E0B" fontSize="8" fontFamily="Fira Code, monospace">SELECT</text>
    <text x="52" y="10" fill={color} fontSize="8" fontFamily="Fira Code, monospace"> f.*, d.name</text>
    <text x="0" y="24" fill="#F59E0B" fontSize="8" fontFamily="Fira Code, monospace">FROM</text>
    <text x="36" y="24" fill={color} fontSize="8" fontFamily="Fira Code, monospace"> fact_sales f</text>
    <text x="0" y="38" fill="#F59E0B" fontSize="8" fontFamily="Fira Code, monospace">JOIN</text>
    <text x="32" y="38" fill={color} fontSize="8" fontFamily="Fira Code, monospace"> dim_customer d</text>
    <text x="0" y="52" fill="#F59E0B" fontSize="8" fontFamily="Fira Code, monospace">ON</text>
    <text x="18" y="52" fill={color} fontSize="8" fontFamily="Fira Code, monospace"> f.cust_id = d.id</text>
  </svg>
);

const KeyTableSketch = ({ className, color = "#06B6D4" }) => (
  <svg width="110" height="60" className={className} viewBox="0 0 110 60">
    <rect width="110" height="60" rx="3" fill="none" stroke={color} strokeWidth="0.8" />
    <rect width="110" height="18" rx="3" fill={color} fillOpacity="0.07" stroke={color} strokeWidth="0.8" />
    <text x="55" y="13" textAnchor="middle" fill={color} fontSize="8" fontFamily="Fira Code, monospace" fontWeight="600">ORDERS</text>
    <text x="8" y="32" fill="#F59E0B" fontSize="7" fontFamily="Fira Code, monospace">PK</text>
    <text x="30" y="32" fill={color} fontSize="7.5" fontFamily="Fira Code, monospace">order_id</text>
    <text x="8" y="48" fill="#22C55E" fontSize="7" fontFamily="Fira Code, monospace">FK</text>
    <text x="30" y="48" fill={color} fontSize="7.5" fontFamily="Fira Code, monospace">cust_id</text>
  </svg>
);

/* ===== Main ER Background Component ===== */
/* Each decoration is absolutely positioned within the main relative container */
const base = "absolute pointer-events-none select-none";

const ERBackground = () => {
  return (
    <>
      {/* ===== HERO AREA ===== */}
      <EntitySketch
        className={`${base} top-[80px] left-[20px] opacity-[0.05]`}
        name="EMPLOYEE"
        cols={["PK emp_id INT", "   name VARCHAR", "FK dept_id INT"]}
      />
      <SQLSketch className={`${base} top-[100px] right-[30px] opacity-[0.04] hidden xl:block`} />
      <CrowsFootSketch className={`${base} top-[300px] right-[50px] opacity-[0.045] hidden lg:block`} />
      <DBCylinderSketch className={`${base} top-[500px] right-[20px] opacity-[0.04] hidden lg:block`} label="DW" />

      {/* ===== ABOUT AREA ===== */}
      <StarSchemaSketch className={`${base} top-[900px] right-[15px] opacity-[0.05] hidden xl:block`} />
      <EntitySketch
        className={`${base} top-[1150px] left-[10px] opacity-[0.04] hidden lg:block`}
        name="DEPARTMENT"
        cols={["PK dept_id", "   dept_name", "   manager"]}
        color="#F59E0B"
      />
      <RelDiamondSketch className={`${base} top-[1350px] left-[30px] opacity-[0.04] hidden lg:block`} label="OWNS" />

      {/* ===== EXPERIENCE AREA ===== */}
      <ETLSketch className={`${base} top-[1550px] left-[30px] opacity-[0.04] hidden xl:block`} />
      <EntitySketch
        className={`${base} top-[1800px] right-[10px] opacity-[0.045] hidden xl:block`}
        name="PROJECT"
        cols={["PK proj_id", "   proj_name", "FK team_id", "   status"]}
      />
      <CrowsFootSketch className={`${base} top-[2050px] left-[40px] opacity-[0.04] hidden lg:block`} />
      <DBCylinderSketch className={`${base} top-[2200px] left-[15px] opacity-[0.035] hidden lg:block`} label="OLAP" color="#F59E0B" />

      {/* ===== SKILLS AREA ===== */}
      <StarSchemaSketch className={`${base} top-[2500px] left-[5px] opacity-[0.04] hidden xl:block`} color="#06B6D4" />
      <KeyTableSketch className={`${base} top-[2700px] right-[15px] opacity-[0.045] hidden xl:block`} />
      <SQLSketch className={`${base} top-[2900px] right-[20px] opacity-[0.035] hidden xl:block`} />

      {/* ===== PROJECTS AREA ===== */}
      <EntitySketch
        className={`${base} top-[3200px] right-[10px] opacity-[0.04] hidden xl:block`}
        name="PATIENT"
        cols={["PK patient_id", "   diagnosis", "FK doctor_id"]}
      />
      <RelDiamondSketch className={`${base} top-[3300px] left-[20px] opacity-[0.04] hidden lg:block`} label="MAPS" />
      <ETLSketch className={`${base} top-[3550px] left-[10px] opacity-[0.035] hidden xl:block`} color="#F59E0B" />

      {/* ===== EDUCATION AREA ===== */}
      <StarSchemaSketch className={`${base} top-[3900px] right-[10px] opacity-[0.04] hidden xl:block`} color="#F59E0B" />
      <EntitySketch
        className={`${base} top-[4100px] left-[10px] opacity-[0.035] hidden xl:block`}
        name="SCHEMA_V"
        cols={["PK version_id", "   schema_name", "   created_at"]}
        color="#06B6D4"
      />

      {/* ===== CONTACT AREA ===== */}
      <DBCylinderSketch className={`${base} top-[4600px] left-[20px] opacity-[0.035] hidden lg:block`} label="PROD" color="#06B6D4" />
      <CrowsFootSketch className={`${base} top-[4800px] right-[40px] opacity-[0.04] hidden lg:block`} />
      <KeyTableSketch className={`${base} top-[5000px] right-[15px] opacity-[0.035] hidden xl:block`} />
    </>
  );
};

export default ERBackground;
